import { Mobile, Pc } from '../../hooks/MediaQuery'
import PageCatalogPc from './PageCatalogPc'
import PageCatalogMobile from './PageCatalogMobile'

function PageCatalog() {
  return (
    <>
      <Pc>
        <PageCatalogPc />
      </Pc>
      <Mobile>
        <PageCatalogMobile />
      </Mobile>
    </>
  )
}

export default PageCatalog
